import { z } from 'zod';
import { Api } from '@automapa/svelte-automapa-template';
import type { ZoneType, ZoneCreateType, ZoneGeomType } from './types';
import { ZoneCreateSchema, ZoneSchema, ZoneGeomSchema } from './types';
import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';

export const SimpleZoneSchema = z.object({
    id: z.number(), // zone_id
    map_id: z.number(),
    vehicle_id: z.number().nullable(),
});
export type SimpleZoneType = z.infer<typeof SimpleZoneSchema>;

export class ZoneApi {
    public static async getAll(api: Api): Promise<ZoneType[]> {
        return api.getData<undefined, ZoneType[]>(
            'get',
            '/zones',
            undefined,
            z.undefined(),
            z.array(ZoneSchema)
        );
    }

    public static async getAllByMapId(api: Api, map_id: number): Promise<ZoneType[]> {
        let f = new ApiFilterBuilder(null);
        f.sortBy(['order_by', 'id'], ['asc', 'asc']);
        f.filterByNumber('map_id', map_id);
        return api.getData<undefined, ZoneType[]>(
            'get',
            // '/zones?filter[map_id]=' + map_id,
            '/zones' + f.getUri(),
            undefined,
            z.undefined(),
            z.array(ZoneSchema)
        );
    }

    public static async getOne(api: Api, zoneId: number): Promise<ZoneType> {
        return api.getData<undefined, ZoneType>(
            'get',
            `/zone/${zoneId}?relations[0]=map`,
            undefined,
            z.undefined(),
            ZoneSchema
        );
    }

    public static async create(api: Api, zone: ZoneCreateType): Promise<ZoneType> {
        return api.getData<ZoneCreateType, ZoneType>(
            'post',
            '/zone',
            zone,
            ZoneCreateSchema,
            ZoneSchema
        );
    }

    public static async removeOne(api: Api, zoneId: number): Promise<any> {
        return api.delete(`/zone/${zoneId}`);
    }

    public static async removeAllByMapId(api: Api, map_id: number): Promise<ZoneType[]> {
        return api.getData<undefined, ZoneType[]>(
            'delete',
            '/zones?filter[map_id]=' + map_id,
            undefined,
            z.undefined(),
            z.any()
        );
    }

    /*
    POST https://lastmile-test.automapa.pl/api/zones/query?page%5Blimit%5D=-1&page%5Boffset%5D=0&projection=map_id,vehicle_id
Accept: application/json, text/plain,
    {
        "map_id": { "$in": [359, 360] }
    }
*/
    public static async getSimpleZones(api: Api, map_ids: number[]): Promise<SimpleZoneType[]> {
        let f = new ApiFilterBuilder(null);
        f.setProjectionFields(['id', 'map_id', 'vehicle_id']);
        return api.getData<any, SimpleZoneType[]>(
            'post',
            '/zones/query' + f.getUri(),
            {
                map_id: { $in: map_ids },
            },
            z.any(),
            z.array(SimpleZoneSchema)
        );
    }

    public static async createFromCoords(api: Api, params: {map_id: number, vehicle_ids: number[], coords: {type: string, coordinates: number[]}, day: string, limit: number, radius: number, zones: ZoneType[]}): Promise<any> {
        return api.getData<any, ZoneGeomType>(
            'post',
            '/zone/createFromCoords',
            params,
            z.any(),
            z.any()
        );
    }

}
